import TencentCloudChat from "@tencentcloud/chat";

export const MESSAGE_TYPE = {
  [TencentCloudChat.TYPES.MSG_TEXT]: "text", //文本消息
  [TencentCloudChat.TYPES.MSG_IMAGE]: "image", //图片消息
  [TencentCloudChat.TYPES.MSG_FILE]: "file", //文件消息
  [TencentCloudChat.TYPES.MSG_CUSTOM]: "custom", //自定义消息
  [TencentCloudChat.TYPES.MSG_AUDIO]: "audio", //音频消息
  [TencentCloudChat.TYPES.MSG_VIDEO]: "video", //视频消息
  [TencentCloudChat.TYPES.MSG_MERGER]: "merger", //合并消息
  [TencentCloudChat.TYPES.MSG_LOCATION]: "location", //位置消息
  [TencentCloudChat.TYPES.MSG_FACE]: "face", //表情消息
  [TencentCloudChat.TYPES.MSG_GRP_TIP]: "grp_tip", //群提示消息
  [TencentCloudChat.TYPES.MSG_GRP_SYS_NOTICE]: "grp_sys_notice", //群系统通知消息
};
